import React from 'react';
import { Card, CardContent } from '../ui/card';
import {
  Sheet, SheetContent, SheetHeader, SheetTitle,
} from '../ui/sheet';
import { LockSimple } from '@phosphor-icons/react';
import { STATUS_CONFIG } from '../DocumentShared';

export function VersionHistorySheet({ open, onOpenChange, versionHistory }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-md overflow-y-auto" aria-describedby="history-desc">
        <SheetHeader>
          <SheetTitle>Historique des versions</SheetTitle>
          <p id="history-desc" className="text-sm text-[#4B5563]">Versions validees du document</p>
        </SheetHeader>
        <div className="space-y-3 mt-6" data-testid="version-history-list">
          {versionHistory.current && (
            <Card className={`border-2 ${versionHistory.current.status === 'valide' ? 'border-emerald-300' : 'border-orange-300'}`}>
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <span className="font-bold text-lg">V{versionHistory.current.version}</span>
                    <span className={`ml-2 px-2 py-0.5 rounded text-xs font-bold ${(STATUS_CONFIG[versionHistory.current.status] || {}).badge || 'bg-gray-100'}`}>
                      {(STATUS_CONFIG[versionHistory.current.status] || {}).label || versionHistory.current.status}
                    </span>
                    <span className="ml-2 text-xs bg-orange-100 text-orange-700 px-2 py-0.5 rounded font-medium">Courante</span>
                  </div>
                </div>
                {versionHistory.current.updated_at && (
                  <p className="text-xs text-gray-500 mt-1">
                    {new Date(versionHistory.current.updated_at).toLocaleDateString('fr-FR')} a {new Date(versionHistory.current.updated_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                  </p>
                )}
              </CardContent>
            </Card>
          )}
          {[...(versionHistory.history || [])].reverse().map((v) => (
            <Card key={`v${v.version}-${v.validated_at}`} className="border border-gray-200">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <span className="font-bold text-lg">V{v.version}</span>
                    <span className="ml-2 px-2 py-0.5 rounded text-xs font-bold bg-emerald-100 text-emerald-700">Valide</span>
                  </div>
                  <LockSimple size={16} className="text-emerald-500" />
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Valide le {v.validated_at ? new Date(v.validated_at).toLocaleDateString('fr-FR') : '-'}
                  {v.validated_by_name && ` par ${v.validated_by_name}`}
                </p>
              </CardContent>
            </Card>
          ))}
          {(versionHistory.history || []).length === 0 && !versionHistory.current && (
            <p className="text-center text-gray-500 py-8">Aucun historique</p>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
